import React from 'react';
import QRCode from "react-qr-code";
import { IconClose, IconLink, IconPdf } from '../util/Icons';
// eslint-disable-next-line no-unused-vars
import ModelCheck from '../model/ModelCheck';
import WrittenPng from "../assets/images/wv_logo_written.png"
import Apis from '../api/Apis';

const DialogShare = (props) => {
    const isMobile = window.innerWidth < 768
    /** @type {ModelCheck} */
    const check = props.data

    function onClickClose() {
        props.onClose()
    }

    async function  downloadPDF() {
        if (isDownloadAvailable()) {
            Apis.downloadPDF(check.certificateCode)
        }
    }

    function onClickCopyLink() {
        let link = window.location.href
        navigator.clipboard.writeText(link)
        alert('Link copied to clipboard')
    }

    const isDownloadAvailable = () => {
        if (check.checkStatus === 5 || check.checkStatus ===  25) {
            return true
        }
        return false
    }

    return (
        <div className='dialog-background'>
            {
                !isMobile &&
                <div className='flex-max share-header' style={{color: "white"}}>
                    <div className='clicable' style={{ textAlign: "start" }} onClick={onClickClose}>
                        <IconClose  color='white' size={28}/> 
                    </div>
                    <p></p>
                    <p></p>

                </div>
            }
            <div className='dialog'>

                {
                    isMobile && 
                    <div className='flex-max share-header' style={{color: "white"}}>
                        <div className='clicable' style={{ textAlign: "start" }} onClick={onClickClose}>
                            <IconClose color='white' size={28}/> 
                        </div>
                        <p style={{textAlign: "center"}}>Share</p>
                        <p></p>
                    </div>
                }

                <div className='share-cards-center'>
                    <div className='card-white'>
                        <div className='qrcode-container'>
                            <p>{check.teamName} - {check.brandName}</p>
                            <QRCode value={check.qrCode} /> 
                            {/* <img src={check.qrCode} /> */}
                            <p>ID: {check.certificateCode}</p>
                        </div>
                    </div>
                    <div className='flex-max'>
                        <div className={'card-grey'} onClick={() => {}}> 
                            <IconPdf size={28}/>
                            <p>Download</p>
                        </div>
                    <div className='card-white clicable'  onClick={onClickCopyLink}>
                            <IconLink size={28}/>
                            <p>Copy link</p>
                        </div>
                    </div>
                </div>
                <div className='share-footer'>
                    <p>Certified by</p> 
                    <img src={WrittenPng} alt="" />
                    <p>Copyright @ 2023</p>
                </div>
            </div>
        </div>
    )
}

export default DialogShare